<div class="NgxEditor__MenuItem NgxEditor__MenuItem--ItemContainer" (mousedown)="onClick($event)">
    <button
        type="button"
        class="NgxEditor__MenuItem--Icon"
        [class.NgxEditor__MenuItem--Active]="isActive"
        title="Insert Link"
        aria-label="Insert Link"
        aria-expanded="false"
        aria-haspopup="dialog"
    >
        <i class="fa-regular br-link fa-link" title="link"></i>
    </button>
</div>

<aix-modal
    #addLinkModal
    modalType="confirmation"
    [data-testing]="'addLinkModal'"
    [modalTitle]="'Add Link'"
    [buttonOptions]="['Cancel', 'Add Link']"
    [buttonDisableFunction]="addLinkModalIsInvalid"
    (onCloseModal)="onCloseModal()"
    (optionSelected)="addLinkModalSelected($event)"
>
    <ng-template>
        <form [formGroup]="_form" class="addLinkPopup__form">
            <div class="aix-form__group">
                <aix-input
                    formControlName="url"
                    [data-testing]="'urlFieldInput'"
                    [config]="{ refId: 'url' }"
                    [isValid]="true"
                >
                    URL
                </aix-input>
            </div>
            <div class="aix-form__group">
                <aix-input
                    formControlName="text"
                    [data-testing]="'textFieldInput'"
                    [config]="{ refId: 'text' }"
                    [isValid]="true"
                >
                    Text
                </aix-input>
            </div>
        </form>
    </ng-template>
</aix-modal>
